import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'chunkify',
  standalone: false,
})
export class ChunkifyPipe<T = unknown> implements PipeTransform {
  transform(value: T[] | null | undefined, chunkSize = 1, fill = false): T[][] {
    if (!Array.isArray(value) || value.length === 0) {
      return [];
    }
    const size = Math.max(1, Math.floor(Number(chunkSize) || 1));
    const chunks: T[][] = [];
    for (let i = 0; i < value.length; i += size) {
      chunks.push(value.slice(i, i + size));
    }
    if (fill && chunks[chunks.length - 1].length < chunkSize) {
      const remaining = chunkSize - chunks[chunks.length - 1].length;
      chunks[chunks.length - 1] = [
        ...chunks[chunks.length - 1],
        ...Array(remaining).fill(undefined),
      ];
    }
    return chunks;
  }
}
